import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
    selector: "edp-banner-app",
    templateUrl: "./edp-banner-app.component.html",
    styleUrls: ["./edp-banner-app.component.scss"],
})
export class EdpBannerAppComponent {
    public storeLink: string;

    constructor(private readonly deviceDetector: DeviceDetectorService, private readonly translate: TranslateService) {
        const isIOS = this.deviceDetector.getDeviceInfo().os.toLowerCase() === "ios";
        this.storeLink = isIOS
            ? this.translate.instant("pt.edp.edponline.general.appleStoreLink")
            : this.translate.instant("pt.edp.edponline.general.googleStoreLink");
    }
}
